import React from 'react'
import PropTypes from 'prop-types'
import { animated, useSpring } from '@react-spring/web'
import { alpha, IconButton, makeStyles } from '@material-ui/core'
import Icon from '../../atoms/Icon'
import { cssVar } from '../../../utils/cssVar'
import { useHomeDashboard } from './HomeDashboardContext'

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    alignSelf: 'flex-end'
  },
  fullViewOptions: {
    display: 'flex',
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    zIndex: 1,
    borderRadius: 'var(--border-radius-round)',
    backgroundColor: ({ framed }) => framed ? 'var(--color-surface-050)' : 'transparent',
    border: ({ framed }) => framed ? `1px solid ${alpha(cssVar('--color-primary-500'), 0.5)}` : 'none'
  },
  [theme.breakpoints.down('xs')]: {
    actionButtons: {
      display: 'none'
    }
  }
}))

const ActionButtons = ({ hidden, idle, framed }) => {
  const { toggleExpanded, expanded } = useHomeDashboard()
  const classes = useStyles({ expanded, framed })
  const springs = useSpring({
    to: { opacity: idle ? 0 : 1 },
    from: { opacity: 1 },
    leave: { opacity: 0 }
  })

  if (hidden) return null

  return (
    <animated.div className={classes.actionButtons} style={springs}>
      <div className={classes.fullViewOptions}>
        <IconButton
          aria-label='expand full view'
          aria-haspopup='true'
          onClick={toggleExpanded}
          color='inherit'
        >
          <Icon
            customSize='1.2rem'
            name={expanded ? 'collapse' : 'expand'}
          />
        </IconButton>
      </div>
    </animated.div>
  )
}

ActionButtons.propTypes = {
  framed: PropTypes.bool,
  hidden: PropTypes.bool,
  idle: PropTypes.bool
}

ActionButtons.defaultProps = {
  framed: false,
  hidden: false,
  idle: false
}

export default ActionButtons
